import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .select {
      &:not(:last-of-type) {
         margin-bottom: 10px;
      }
      h4 { width: 104px; }
   }
   .textInput {
      h4 { width: 114px; }
      &:not(:last-of-type) { margin-bottom: 10px; }
   }
   .textarea {
      > div {
         height: 92px;
         min-height: 92px;
      }
   }
   .action {
      position: relative;
      display: flex;
      gap: 7.5px;
      align-items: center;
      padding-bottom: 10px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
      .btn1 {
         margin-top: 3px;
      }
   }
`;
